import { LINKS_DESIGN_TYPE } from "../interfaces"

export const getClassNameByDesignLinkType = (type: LINKS_DESIGN_TYPE) => {
    switch (type) {
        case LINKS_DESIGN_TYPE.ROUND:
            return "rounded-pill bg-contrast text-plain flex-centered hover" 
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE:
        case LINKS_DESIGN_TYPE.ROUND_OUTLINE_BW:
            return "rounded-pill flex-centered text-contrast border1 border-force hover" 
        case LINKS_DESIGN_TYPE.MINIMAL:
            return "minimal text-contrast flex-centered hover"
        case LINKS_DESIGN_TYPE.OUTLINE:
        case LINKS_DESIGN_TYPE.OUTLINE_BW:
            return "border1 border-force-secondary-opacity text-contrast flex-centered hover"
        case LINKS_DESIGN_TYPE.SMALL:
            return "sm flex-centered hover"
        case LINKS_DESIGN_TYPE.SMALL_ROUND:
            return "rounded-pill sm bg-contrast text-plain flex-centered hover"
        case LINKS_DESIGN_TYPE.SMALL_MINIMAL:
            return "minimal sm  text-contrast flex-centered hover" 
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE:
        case LINKS_DESIGN_TYPE.SMALL_OUTLINE_BW:
            return "sm border1 border-force-secondary-opacity text-contrast hover" 
        case LINKS_DESIGN_TYPE.SQUARE:
        default:
            return " flex-centered hover "
    }
}